export default __webpack_public_path__ + "static/media/down-arrow-light.22e7aff4.svg";